export default function NotFound() {
  return (
    <div style={{ marginTop: '30vh' }}>
      <h1>Cette page n'existe pas</h1>
      <p>Un jour peut-être ?</p>
    </div>
  );
}
